import { render, staticRenderFns } from "./DayangDetail.vue?vue&type=template&id=2f614e54&scoped=true&"
import script from "./DayangDetail.vue?vue&type=script&lang=js&"
export * from "./DayangDetail.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=2f614e54&prod&scoped=true&lang=css&"
import style1 from "./DayangDetail.vue?vue&type=style&index=1&id=2f614e54&prod&scoped=true&lang=css&"
import style2 from "./DayangDetail.vue?vue&type=style&index=2&id=2f614e54&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f614e54",
  null
  
)

export default component.exports